import { AppMode } from "../values";
import { dark_mode_primary } from "../values";

export function Footer({ appMode }) {
    return (
        <footer className={`${appMode === AppMode.LIGHT ? 'bg-[#222222]' : dark_mode_primary} px-3.5 py-7 mx-auto flex items-center sm:flex-row flex-col`}>
            <p className="text-sm text-gray-200 sm:ml-4 sm:pl-4 sm:py-2 sm:mt-0 mt-4">© 2025 Corella</p>
            <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
                <a href='https://x.com/' className="text-gray-200"><i className="text-lg bi bi-twitter-x hover:text-black"></i></a>
                <a href='https://instagram.com/' className="ml-5 text-gray-200"><i className="text-lg bi bi-instagram hover:text-pink-600"></i></a>
                <a href='https://linkedin.com/' className="ml-5 text-gray-200"><i className="text-lg bi bi-linkedin hover:text-blue-600"></i></a>
            </span>
        </footer>
    )
}